import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Button
} from "@mui/material";
import { Close as CloseIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

function TranslationEditorGuide({ open, onClose }) {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Translation Editor User Guide</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Accordion disabled>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6" color="primary">
                            Oldingi to'liq qo'llanma (cheklangan versiyada o'chirilgan)
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2" color="text.secondary">
                            Bu bo'lim limited edition uchun ataylab yopilgan.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6" color="secondary">
                            Translation Editor (Limited Edition) - Foydalanish yo'riqnomasi
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <List>
                            <ListItem>
                                <ListItemText
                                    primary="1. Matnni va mavjud tarjimani tekshirib chiqing"
                                    secondary="Sahifa ochilganda matn hamda saqlangan tarjima yuklanadi. Agar tarjima topilmasa, tizim bu haqda xabar beradi."
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary="2. 'Whole Text Translation' bo'limida umumiy tarjimani kiriting yoki tahrir qiling"
                                    secondary="Butun matn tarjimasini yozing, kerak bo'lsa qayta tahrirlang va saqlang."
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary="3. 'Words dictionary' ni ochib so'zlarni boshqaring"
                                    secondary="So'z tarjimalari, izohlar va grammatika havolalarini lug'at dialogi ichida yangilang."
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary="4. 'Word-by-Word Editing' bo'limida har bir so'zni tekshiring"
                                    secondary="So'z chegaralarini, bog'langan tarjimani va grammar topic maydonini ko'rib chiqing. Tarjima maydoni ustiga bosib lug'atni tez ochishingiz mumkin."
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary="5. Natijani ko'rish uchun 'View Translation' dan foydalaning"
                                    secondary="Yakuniy ko'rinishni tekshirib, matn oqimi to'g'ri ekanini tasdiqlang."
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary="6. Oxirida 'Save' tugmasini bosing"
                                    secondary="Barcha o'zgarishlarni serverga saqlaydi."
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary="Muhim eslatma (Limited Edition)"
                                    secondary="Auto-Translate, Builder va AI Assistant bloklari ushbu versiyada o'chirilgan. Jarayon qo'lda tahrirlashga yo'naltirilgan."
                                    primaryTypographyProps={{ color: 'warning.main', fontWeight: 'bold' }}
                                />
                            </ListItem>
                        </List>
                    </AccordionDetails>
                </Accordion>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export default TranslationEditorGuide; 